import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CapacityPlanDeliveryIssuesQueryVariables = Types.Exact<{
  runId: Types.Scalars['ID'];
}>;


export type CapacityPlanDeliveryIssuesQuery = { __typename?: 'Query', capacityPlanDeliveryIssues: Array<{ __typename?: 'CapacityPlanDeliveryIssue', kind: Types.CapacityPlanDeliveryIssueKind, reason: string, count: number }> };


export const CapacityPlanDeliveryIssuesDocument = gql`
    query CapacityPlanDeliveryIssues($runId: ID!) {
  capacityPlanDeliveryIssues(runId: $runId) {
    kind
    reason
    count
  }
}
    `;

/**
 * __useCapacityPlanDeliveryIssuesQuery__
 *
 * To run a query within a React component, call `useCapacityPlanDeliveryIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityPlanDeliveryIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityPlanDeliveryIssuesQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useCapacityPlanDeliveryIssuesQuery(baseOptions: Apollo.QueryHookOptions<CapacityPlanDeliveryIssuesQuery, CapacityPlanDeliveryIssuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityPlanDeliveryIssuesQuery, CapacityPlanDeliveryIssuesQueryVariables>(CapacityPlanDeliveryIssuesDocument, options);
      }
export function useCapacityPlanDeliveryIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityPlanDeliveryIssuesQuery, CapacityPlanDeliveryIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityPlanDeliveryIssuesQuery, CapacityPlanDeliveryIssuesQueryVariables>(CapacityPlanDeliveryIssuesDocument, options);
        }
export type CapacityPlanDeliveryIssuesQueryHookResult = ReturnType<typeof useCapacityPlanDeliveryIssuesQuery>;
export type CapacityPlanDeliveryIssuesLazyQueryHookResult = ReturnType<typeof useCapacityPlanDeliveryIssuesLazyQuery>;
export type CapacityPlanDeliveryIssuesQueryResult = Apollo.QueryResult<CapacityPlanDeliveryIssuesQuery, CapacityPlanDeliveryIssuesQueryVariables>;